import { useMutation } from '@tanstack/react-query';
import { deleteMasterMedicine } from '../requests';

type DeleteMasterMedicine = (id: string) => Promise<void>;

interface UseDeleteMasterMedicineReturn {
  deleteMasterMedicine: DeleteMasterMedicine;
  isLoading: boolean;
}

export const useDeleteMasterMedicine = (): UseDeleteMasterMedicineReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (id: string) => deleteMasterMedicine(id)
  });

  const deleteMasterMedicineCallback = async (id: string) => {
    const response = await mutateAsync(id);
    return response.data.data;
  };

  return {
    deleteMasterMedicine: deleteMasterMedicineCallback,
    isLoading
  };
};
